export const UserSortAdapter = sort => {
  if (sort.includes("fullName")) {
    return sort.replace("fullName", "name");
  } else if (sort.includes("organizationName")) {
    return sort.replace("organizationName", "name");
  }

  return sort;
};

export const SortAssetsAdapter = sort => {
  if (!sort) {
    return sort;
  }

  let [column, order] = sort.split(",");

  if (column === "balanceKhr") {
    column = "KHR";
  }

  if (column === "balanceUsd") {
    column = "USD";
  }
  return `${column},${order}`;
};

export const SortAdapter = sort => UserSortAdapter(SortAssetsAdapter(sort));

export const AssetsAdapter = account => {
  account.balanceKhr = account.assets["khr#nbc"] || 0;
  account.balanceUsd = account.assets["usd#nbc"] || 0;
  return account;
};
